import * as React from "react";
import { SvgIcon } from "@origin-digital/ods-icons";
import { AssignedIcon, DraftIcon } from "../../Projects/Icons";

export const FilterIcon = () => (
  <SvgIcon color="secondaryB" titleAccess="Drafts Filter">
    <path d="M11 18H13C13.55 18 14 17.55 14 17C14 16.45 13.55 16 13 16H11C10.45 16 10 16.45 10 17C10 17.55 10.45 18 11 18ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM7 13H17C17.55 13 18 12.55 18 12C18 11.45 17.55 11 17 11H7C6.45 11 6 11.45 6 12C6 12.55 6.45 13 7 13Z" />
  </SvgIcon>
);

export const SortResultIcon = () => (
  <SvgIcon color="neutral" titleAccess="Drafts Sort Result">
    <path d="M12.93 2.65c-.2-.2-.51-.2-.71 0l-2.01 2.01h4.72l-2-2.01Zm-.7 18.7c.2.2.51.2.71 0l1.98-1.98h-4.66l1.97 1.98Zm-1.25-3.62c.6 0 1.01-.6.79-1.16L8.04 7.03a1.205 1.205 0 0 0-2.24 0l-3.74 9.53c-.22.56.19 1.16.79 1.16.35 0 .67-.22.8-.55l.71-1.9h5.11l.71 1.9c.13.34.45.56.8.56Zm-6.01-4.09 1.94-5.18 1.94 5.18H4.97Zm16.08 2.5h-5.33l5.72-8.29c.46-.66-.02-1.57-.82-1.57h-6.48c-.44 0-.79.36-.79.8v.01c0 .44.36.8.79.8h5.09l-5.73 8.28c-.46.66.02 1.57.82 1.57h6.72c.44 0 .79-.36.79-.79a.776.776 0 0 0-.78-.81Z" />
  </SvgIcon>
);

export const StatusIcon = ({ status }: { status: string }) => {
  switch (status) {
    case "pencil":
      return <DraftIcon />;
    case "assigned":
      return <AssignedIcon />;
    default:
      return null;
  }
};
